var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestorFlow4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 17.75H21.5V14H14.75V19.8928L15.875 20.9375L18.5 18.125L20.75 21.875L22.25 20L24.5 22.25L22.25 21.875L20.75 23.75L18.5 20.75L16.25 23.375L14.75 22.4375V26H25.25V17.75ZM26.75 17V26.7448C26.7507 26.8432 26.732 26.9409 26.6949 27.0322C26.6579 27.1234 26.6032 27.2065 26.534 27.2766C26.4649 27.3468 26.3826 27.4026 26.2919 27.4409C26.2011 27.4792 26.1037 27.4993 26.0052 27.5H13.9948C13.7974 27.5 13.608 27.4216 13.4684 27.2821C13.3288 27.1426 13.2502 26.9534 13.25 26.756V13.244C13.25 12.8413 13.5867 12.5 14.0015 12.5H22.2477L26.75 17Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestorFlow4);
export default __webpack_public_path__ + "static/media/investor_flow4.672d0847ae7d39fcff11f1380df43c7b.svg";
export { ForwardRef as ReactComponent };